import {app} from '../../app';
import {ISessionService} from "../../services/SessionService";

export class UploadQuestionPreviewComponent {

    protected sessionService:ISessionService;

    question:IQuestion;
    values:{name:string;hash:string;}[] = [];

    static $inject = ['SessionService'];

    constructor(sessionService:ISessionService) {
        this.sessionService = sessionService;
    }

    setup() {
        let answer = this.sessionService.getAnswer(this.question.id);
        if (answer && answer.values.length > 0) {
            for (const value of answer.values) {
                this.values.push(value.value);
            }
        }
    }

}

app.component('uploadQuestionPreview', {
    templateUrl : 'templates/components/questionPreviews/uploadQuestionPreview.html',
    controller  : UploadQuestionPreviewComponent,
    controllerAs: 'uploadQuestionPreview',
    bindings    : {
        question: '<',
    }
});